import { Routes } from '@angular/router';
import { SUPPORT_PERMISSIONS } from './features/access/domain/support-permissions';
import { authGuard, loginGuard, permissionGuard } from './features/auth/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [loginGuard],
    loadComponent: () => import('./features/auth/pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'forgot-password',
    canActivate: [loginGuard],
    loadComponent: () =>
      import('./features/auth/pages/forgot-password/forgot-password.page').then(
        (m) => m.ForgotPasswordPage,
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./features/auth/pages/reset-password/reset-password.page').then(
        (m) => m.ResetPasswordPage,
      ),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./shell/layout-shell.component').then((m) => m.LayoutShellComponent),
    children: [
      {
        path: 'inicio',
        loadComponent: () => import('./features/home/home.page').then((m) => m.HomePage),
      },
      {
        path: 'clientes',
        canActivate: [permissionGuard],
        data: { permission: SUPPORT_PERMISSIONS.LOOKUP_READ },
        loadComponent: () =>
          import('./features/lookup/pages/lookup/lookup.page').then((m) => m.LookupPage),
      },
      {
        path: 'solicitudes',
        canActivate: [permissionGuard],
        data: {
          anyPermission: [
            SUPPORT_PERMISSIONS.CHANGE_REQUESTS_CREATE,
            SUPPORT_PERMISSIONS.CHANGE_REQUESTS_APPROVE,
          ],
        },
        loadComponent: () =>
          import('./features/change-requests/pages/change-requests/change-requests.page').then(
            (m) => m.ChangeRequestsPage,
          ),
      },
      {
        path: 'auditoria',
        canActivate: [permissionGuard],
        data: { permission: SUPPORT_PERMISSIONS.AUDIT_READ },
        loadComponent: () =>
          import('./features/audit/pages/audit/audit.page').then((m) => m.AuditPage),
      },
      { path: '', pathMatch: 'full', redirectTo: 'inicio' },
    ],
  },
  { path: '**', redirectTo: '' },
];
